/** @jsx jsx */
import { css, jsx } from '@emotion/core';

import FocusRing from '@atlaskit/focus-ring';
import { borderRadius } from '@atlaskit/theme/constants';

import { token } from '@atlaskit/tokens';
import CopyToClipboard from './copy-to-clipboard';

const copyValueButtonStyles = css({
  appearance: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '2px 6px',
  color: 'inherit',
  borderRadius: borderRadius(),
  background: token('color.background.neutral.subtle', 'transparent'),

  '&:hover, &:focus': {
    background: token('color.background.neutral.subtle.hovered', '#091E420F'),
  },

  '&:active': {
    background: token('color.background.neutral.subtle.pressed', '#091E4224'),
  },
});

interface CopyButtonProps {
  value: string;
  children: React.ReactNode;
  className?: string;
}

const CopyButton = ({ value, children, className }: CopyButtonProps) => (
  <CopyToClipboard
    value={value}
    messages={{
      prompt: `Copy '${value}' to clipboard`,
      success: 'Copied!',
      fail: 'Copy failed',
    }}
  >
    {({ copy }) => (
      <FocusRing>
        <button
          css={copyValueButtonStyles}
          className={className}
          type="button"
          onClick={copy}
          onMouseDown={(event: React.MouseEvent<HTMLElement>) => {
            event.preventDefault();
          }}
        >
          {children}
        </button>
      </FocusRing>
    )}
  </CopyToClipboard>
);

export default CopyButton;
